var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sale-normal-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "销售信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "125px" } },
            [
              !(_vm.isOA && _vm.specList.length === 0)
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "规格设置" } },
                      [
                        _vm.specList.length < 3 && !_vm.isOA
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", plain: "" },
                                on: { click: _vm.addSkuItem }
                              },
                              [_vm._v("   添加规格项(最多三项)   ")]
                            )
                          : _vm._e(),
                        _vm._l(_vm.specList, function(specItem) {
                          return _c("SpecItemNormal", {
                            key: specItem.id,
                            attrs: {
                              item: specItem,
                              isOA: _vm.isOA,
                              specList: _vm.specList
                            },
                            on: { deleteSpecItemEvent: _vm.deleteSpecItem }
                          })
                        })
                      ],
                      2
                    )
                  ]
                : [
                    _c(
                      "el-form-item",
                      { attrs: { label: "库存方式" } },
                      [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: _vm.stockType,
                              callback: function($$v) {
                                _vm.stockType = $$v
                              },
                              expression: "stockType"
                            }
                          },
                          _vm._l(_vm.stockTypeArr, function(stockItem) {
                            return _c("el-option", {
                              key: stockItem.stockType,
                              attrs: {
                                label: stockItem.stockTypeName,
                                value: stockItem.stockType
                              }
                            })
                          }),
                          1
                        ),
                        _vm.stockType == 2
                          ? _c("span", [
                              _vm._v("   "),
                              _c("i", { staticClass: "el-icon-question" }),
                              _vm._v(
                                " 用户下单,根据库存数量进行判断,用户下单不会减少系统管理库存"
                              )
                            ])
                          : _vm._e(),
                        _vm.stockType == 1
                          ? _c("span", [
                              _vm._v("   "),
                              _c("i", { staticClass: "el-icon-question" }),
                              _vm._v(" 用户下单,根据库存数量进行判断")
                            ])
                          : _vm._e(),
                        _vm.stockType == 0
                          ? _c("span", [
                              _vm._v("   "),
                              _c("i", { staticClass: "el-icon-question" }),
                              _vm._v(" 买家下单不会受到库存数量限制")
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
              _vm.availableSpecList.length > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "价格库存" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("PriceInventoryNormal", {
                                ref: "priceInventoryRef",
                                attrs: {
                                  availableSpecList: _vm.availableSpecList,
                                  isOA: _vm.isOA
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.stockType == 1 || (_vm.specList.length === 0 && !_vm.isOA)
                ? [
                    _vm.specList.length == 0
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "库存", required: "" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "202px" },
                              attrs: {
                                maxlength: "9",
                                placeholder: "请输入商品库存",
                                oninput: "value=value.replace(/[^\\d]/g,'')"
                              },
                              on: { change: _vm.changeStock },
                              model: {
                                value: _vm.currNum,
                                callback: function($$v) {
                                  _vm.currNum = $$v
                                },
                                expression: "currNum"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm.specList.length == 0 &&
              !(_vm.shopConfig && _vm.shopConfig.funcSettingMap.is_off_stand)
                ? _c(
                    "el-form-item",
                    { attrs: { label: "价格", required: "" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "202px" },
                        attrs: {
                          type: "number",
                          min: 0,
                          disabled: _vm.isOA,
                          placeholder: !_vm.cateModel
                            ? "先选择商品分类，才可输入"
                            : "请输入商品价格"
                        },
                        on: {
                          input: _vm.inputMarketPrice,
                          change: _vm.changeMarketPrice
                        },
                        model: {
                          value: _vm.marketPrice,
                          callback: function($$v) {
                            _vm.marketPrice = $$v
                          },
                          expression: "marketPrice"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isOA
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.isPublicDisplayPrice,
                            callback: function($$v) {
                              _vm.isPublicDisplayPrice = $$v
                            },
                            expression: "isPublicDisplayPrice"
                          }
                        },
                        [_vm._v("价格仅对有客户关系的买家显示")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.specList.length == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "起订量" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "202px" },
                        attrs: {
                          type: "number",
                          min: 0,
                          disabled: !_vm.cateModel,
                          placeholder: !_vm.cateModel
                            ? "先选择商品分类，才可输入"
                            : _vm.shopConfig &&
                              _vm.shopConfig.goodsAmountDigit == "0"
                            ? "请输入1以上的整数"
                            : "请输入起订量"
                        },
                        on: { input: _vm.inputMinOrderQuantity },
                        model: {
                          value: _vm.minOrderQuantity,
                          callback: function($$v) {
                            _vm.minOrderQuantity = $$v
                          },
                          expression: "minOrderQuantity"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.specList.length == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "销售单位", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "202px" },
                          attrs: { filterable: "", placeholder: "请选择" },
                          on: { change: _vm.unitSelectChange },
                          model: {
                            value: _vm.mUnit,
                            callback: function($$v) {
                              _vm.mUnit = $$v
                            },
                            expression: "mUnit"
                          }
                        },
                        _vm._l(_vm.unitsList, function(unitItem) {
                          return _c("el-option", {
                            key: unitItem.unitsCode,
                            attrs: {
                              label: unitItem.unitsName,
                              value: unitItem.unitsCode
                            }
                          })
                        }),
                        1
                      ),
                      _c("span", { staticClass: "pad10-l" }, [
                        _vm._v("按销售单位下单结算")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.shopConfig &&
              _vm.shopConfig.funcSettingMap.is_off_stand &&
              _vm.specList.length == 0
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "计量单位" } },
                      [
                        _c("span", { staticClass: "pad5-r" }, [_vm._v("每")]),
                        _c("el-input", {
                          staticClass: "mar10-r",
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: "请填写换算值",
                            oninput:
                              "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','.').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2.$3')"
                          },
                          model: {
                            value: _vm.unitRatio,
                            callback: function($$v) {
                              _vm.unitRatio = $$v
                            },
                            expression: "unitRatio"
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "140px" },
                            attrs: { filterable: "", placeholder: "请选择" },
                            model: {
                              value: _vm.sUnit,
                              callback: function($$v) {
                                _vm.sUnit = $$v
                              },
                              expression: "sUnit"
                            }
                          },
                          _vm._l(_vm.unitsList, function(unitItem) {
                            return _c("el-option", {
                              key: unitItem.unitsCode,
                              attrs: {
                                label: unitItem.unitsName,
                                value: unitItem.unitsCode
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "pad10-l" }, [
                          _vm._v(
                            "≈1" + _vm._s(_vm.spec && _vm.spec.split("/")[1])
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "价格", required: !_vm.isOA } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "202px" },
                          attrs: {
                            type: "number",
                            min: 0,
                            disabled: _vm.isOA,
                            placeholder: "请输入商品价格"
                          },
                          on: {
                            input: _vm.inputMarketPrice,
                            change: _vm.changeMarketPrice
                          },
                          model: {
                            value: _vm.marketPrice,
                            callback: function($$v) {
                              _vm.marketPrice = $$v
                            },
                            expression: "marketPrice"
                          }
                        }),
                        !_vm.cateModel
                          ? _c("span", { staticClass: "pad10-l" }, [
                              _vm._v("需要先选择商品分类，才可输入")
                            ])
                          : _c("span", { staticClass: "pad10-l" }, [
                              _vm._v(_vm._s(this.spec))
                            ])
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.shopConfig &&
              _vm.shopConfig.funcSettingMap.is_allow_unreal_sales == "1" &&
              _vm.specList.length == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "虚拟销量" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "202px" },
                        attrs: {
                          placeholder: "请填写虚拟销量",
                          oninput:
                            "value=value.replace(/[^\\d^\\.]+/g,'').replace('.','$#$').replace(/\\./g,'').replace('$#$','').replace(/^(\\-)*(\\d+)\\.(\\d\\d).*$/,'$1$2')"
                        },
                        model: {
                          value: _vm.salesVolumeUnreal,
                          callback: function($$v) {
                            _vm.salesVolumeUnreal = $$v
                          },
                          expression: "salesVolumeUnreal"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.specList.length == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "商品编码" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "202px" },
                        attrs: { placeholder: "请输入商品编码" },
                        model: {
                          value: _vm.relationNo,
                          callback: function($$v) {
                            _vm.relationNo = $$v
                          },
                          expression: "relationNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.shopType == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否允许代销", required: "" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.isDealership,
                            callback: function($$v) {
                              _vm.isDealership = $$v
                            },
                            expression: "isDealership"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不可代销")
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("可以代销")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }